import React, { useState, useEffect } from "react";
import {
  FaHospital,
  FaPills,
  FaFileInvoiceDollar,
  FaMedkit,
  FaAppStore,
  FaStore,
  FaPlay,
  FaChartLine,
} from "react-icons/fa";
import img1 from "../../../assets/img/Industries/RetailEcommerce/1.webp";
import img2 from "../../../assets/img/Industries/RetailEcommerce/2.jpg";
import img3 from "../../../assets/img/Industries/RetailEcommerce/3.webp";
import img4 from "../../../assets/img/Industries/RetailEcommerce/f.jpeg";

const HealthcareCard = ({ title, description, icon, imageUrl }) => (
  <div className="bg-white rounded-2xl shadow-xl w-full overflow-hidden transition-all duration-300 hover:shadow-2xl hover:scale-105 mx-auto">
    <div className="h-48 overflow-hidden">
      <img src={imageUrl} alt={title} className="w-full h-full object-cover" />
    </div>
    <div className="p-6">
      <div className="flex items-center mb-4">
        {/* <div className="text-3xl text-blue-600 mr-3">{icon}</div> */}
        <h3 className="text-xl font-bold text-gray-800 min-h-[60px]">{title}</h3>
      </div>
      <p className="text-gray-600">{description}</p>
    </div>
  </div>
);

const EnhancedHealthcareTech = () => {
  const healthcareAreas = [
    {
      title: "Brick-and-Mortar Stores",
      description:
        "Modernize physical stores with IoT, AR, and AI-powered analytics to enhance in-store experiences.",
      icon: <FaStore />,
      imageUrl: img1,
    },
    {
      title: "Pure-Play E-Commerce",
      description:
        " Build scalable, secure platforms with AI and cloud technologies to drive conversions and customer satisfaction.",
      icon: <FaPlay />,
      imageUrl: img2,
    },
    {
      title: "Retail Supply Chain",
      description:
        "Optimize claims management and fraud detection with AI and blockchain solutions.",
      icon: <FaChartLine />,
      imageUrl: img3,
    },
    {
      title: "Marketplace Platforms",
      description:
        "Create feature-rich, multi-vendor marketplaces with robust analytics and payment integrations.",
      icon: <FaMedkit />,
      imageUrl: img4,
    },
  ];

  return (
    <div className="min-h-[70vh]] bg-gradient-to-br from-blue-50 to-green-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-4">
          Transforming Key Areas of Retail & E-Commerce
        </h1>
        <p className="text-xl text-center text-gray-600 mb-12">
          Revolutionizing Retail and E-Commerce for a Smarter Future
        </p>
        <div className="grid grid-cols-1 w-full md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-14">
          {healthcareAreas.map((area, index) => (
            <HealthcareCard key={index} {...area} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnhancedHealthcareTech;
